<template>
  <v-dialog persistent v-model="get_dialogMain.dialog"
    :max-width="get_dialogMain.withWindows"
    transition="dialog-top-transition"
    justify-center>
    <v-toolbar dense dark color="blue darken-2">
      <v-btn v-if="showReturnForm" class="hidden-xs-only" @click="ReturnForm" icon>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title> <h3>{{ get_dialogMain.title }}</h3></v-toolbar-title>
      <v-spacer/>
      <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card title>
      <v-card-text>
        <v-row dense class="pt-3">
          <v-col cols="12" v-if="showFieldFamilia" class="pt-4">
            <SelectedGroupMain :setterModel="FamiliaSelected" :itemAction="selectFamiliaField" :on-success="ActionFieldData" />
          </v-col>
            <v-col cols="12" v-else-if="showFieldActividad" class="pt-4">
             <SelectedMain :setterModel="ActividadSelected" :itemAction="selectActividadField" :on-success="ActionFieldData" />
             </v-col>
          <MainGeneralForm v-if="showFormSecound" :form="formSecound" :model="objectSecound" :params="paramsForm" :on-success="save" :on-cancel="cancel" />
          <MainProcessForm v-if="showFormMain && formMain.status_finish" :form="formMain" :modelmain="objectMain" :on-success="saveProcess" :on-cancel="cancel" />
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SelectedGroupMain from '@/components/fields/selectedGroupMain'
import MainGeneralForm from '@/components/forms/main/MainGeneralForm'
import MainProcessForm from '@/components/forms/main/MainProcessForm'
export default {
  props: ['onSuccess'],
  data: () => ({
    model: null,
    params: null,

    showFieldActividad: false,
    ActividadSelected: 0,
    ActividadObjet: null,
    selectActividadField: {
      name: 'Tipo Actividad',
      nameid: 'tipo_actividad_id',
      object_name: 'tipo_actividad',
      url: '/empresa/tipo-actividades/show-solicitudes',
      value: 'id'
    },
    showFieldFamilia: false,
    FamiliaSelected: 0,
    selectFamiliaField: { name: 'Familia-SubFamilia', nameid: 'familia_id', url: '/catalogo/familias/subfamilias', params: '', showFamilia: false },

    showReturnForm: false,
    idMain: 0,

    showFormMain: false,
    formMain: {},
    objectMain: {},
    paramsDialog: {},
    updateMain: false,

    showFormSecound: false,
    formSecound: {},
    objectSecound: {},
    paramsForm: {},

    fields: {},
    UrlexecuteMain: null
  }),
  components: {
    SelectedGroupMain,
    MainGeneralForm,
    MainProcessForm

  },
  mounted () {
    this.UrlexecuteMain = null
    this.model = this.get_dialogMain.body.objectMain
    this.params = this.get_dialogMain.body.paramsDialog
    this.paramsForm = (this.params.paramsForm) ? this.params.paramsForm : {}
    if (this.params.showActividad) {
      if (this.params.updated) {
        this.updateMain = this.params.updated
        this.objectMain = JSON.parse(JSON.stringify(this.model.descripcion))
        this.ActividadSelected = this.model.tipo_actividade_id
        this.showFieldActividad = true
      } else {
        this.showFieldActividad = this.params.showActividad
        if (this.params.setmodel) this.objectMain = JSON.parse(JSON.stringify(this.model))
      }
    } else if (this.params.showFamilia) {
      this.selectFamiliaField.params = (this.params.familiaParams) ? this.params.familiaParams : ''
      if (this.params.updated) {
        if (this.params.familiaSelected) this.FamiliaSelected = this.params.familiaSelected
        this.objectSecound = JSON.parse(JSON.stringify(this.params.data))
      } else {
        if (this.params.setmodel) this.objectSecound = JSON.parse(JSON.stringify(this.model))
      }
      this.showFieldFamilia = true
    } else if (this.params.form) {
      this.formSecound = JSON.parse(JSON.stringify(this.params.form))
      if (this.params.setmodel) this.objectSecound = Object.assign({}, this.model)
      this.showFormSecound = true
    } else if (this.get_dialogMain.form === 'process') {
      this.showFormMain = true
      if (this.model.action) {
        if (this.params.setmodel) this.objectMain = this.params.data
        this.formMain = JSON.parse(JSON.stringify(this.model.body))
        return
      }
      if (this.params.setmodel) this.objectMain = this.model
      this.GETOptionService({ url: this.params.urloption, params: '/1', replace: '[/{status_id}]' })
    }
  },
  methods: {
    ...mapActions(['POSTExecuteService', 'GETOptionFormService', 'GETOptionService', 'GetObjectFamilia',
      'urlPostServicesAction', 'getFormServicesAction', 'urlGetServiceActionTwo', 'postExecuteAction', 'POSTExecuteMultipart']),
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA', 'SET_DATA_OBJECT', 'CLEAR_OBJECTS_MODEL', 'SEND_DATA_VIEW', 'HIDDE_LOADING_MAIN', 'LOADING_MAIN_DIALOG']),
    ActionFieldData (obj) {
      if (obj.id === 'tipo_actividad_id') {
        // console.log('obj.data', obj)
        this.ActividadSelected = obj.data
        if (obj.data) {
          this.ActividadObjet = obj.objectdata
          const router = this.get_urls[obj.objectdata.permiso]
          this.GETOptionService({ url: router, params: '/1', replace: '[/{status_id}]' })
        } else {
          this.ActividadObjet = null
        }
      } else if (obj.id === 'familia_id') {
        this.FamiliaSelected = obj.data
        const router = this.get_urls['catalogo.familias-caracteristica.formulario']
        this.GetObjectFamilia({ url: router, params: `/${obj.data}`, replace: '/{id}' })
      }
    },
    ReturnForm () {
      this.showReturnForm = false
      this.showFieldFamilia = true
      this.showFormMain = false
      this.showFormSecound = true
      // console.log('ReturnForm')
    },
    createFormDataProcess (object, files) {
      const formData = new FormData()
      Object.entries(object).forEach(([key, value]) => {
        if (value instanceof Object) formData.append(key, JSON.stringify(value))
        else if (value instanceof Array) formData.append(key, JSON.stringify(value))
        else formData.append(key, value)
      })
      this.formMain.status_finish.formulario.fields.map((field, i) => {
        if (field.field === files) formData.append(field.nameid, object.descripcion[field.nameid])
      })
      return formData
    },
    createFormData (object, form) {
      const formData = new FormData()
      form.map(field => {
        formData.append(field.nameid, object[field.nameid])
        if (field.objectname) formData.append(field.objectname, object[field.objectname])
      })
      return formData
    },
    save (model) {
      if (this.params.showFamilia) {
        this.objectSecound = model
        if (this.params.updated) { this.objectMain = this.model }
        this.showReturnForm = true
        this.showFieldFamilia = false
        this.showFormSecound = false
        this.GETOptionService({ url: this.params.urloption, params: '/1', replace: '[/{status_id}]' })
        return
      } else if (this.params.formdata) {
        const formData = this.createFormData(model, this.params.form)
        this.POSTExecuteMultipart({ url: this.params.url, data: formData })
        return
      }

      if (!this.params.url) {
        this.HIDDE_LOADING_MAIN(false)
        this.SEND_DATA_VIEW({ name: this.get_dialogMain.type, model: model })
        this.cancel()
        return
      }

      this.postExecuteAction({ url: this.params.url, data: model })
    },
    saveProcess (model) {
      if (this.get_dialogMain.body && this.get_dialogMain.body.method === 'form-data') {
        if (this.model.item) model.id = this.model.item.id
        else if (this.model.id) model.id = this.model.id
        const formData = this.createFormDataProcess(model, 'fileInputDataServer')
        // const router = this.get_urls['factura.execute']
        // console.log('formData', formData)
        this.POSTExecuteMultipart({ url: this.params.url, data: formData })
        return
      }
      // if (this.get_dialogMain.body && this.get_dialogMain.body.method === 'form-data-bajas') {
      //   const formData = this.createFormDataProcess(model, 'fileInputDataServer')
      //   const router = this.get_urls['bajas.execute']
      //   this.POSTExecuteMultipart({ url: router, data: formData })
      //   return
      // }
      // if (this.get_dialogMain.body && this.get_dialogMain.body.method === 'form-data-inventario') {
      //   const formData = this.createFormDataProcess(model, 'fileInputDataServer')
      //   const router = this.get_urls['inventario.execute']
      //   this.POSTExecuteMultipart({ url: router, data: formData })
      //   return
      // }
      if (this.model.item) model.id = this.model.item.id
      else if (this.model.id) model.id = this.model.id

      if (this.params.showActividad) {
        if (this.params.updated) model.action = 'toUpdate'
        model.tipo_actividad_id = this.ActividadSelected
        this.UrlexecuteMain = this.get_urls[this.ActividadObjet.accion]
      } else if (this.params.showFamilia) {
        if (this.params.updated) model.action = 'toUpdate'
        model.descripcion.familia_id = this.FamiliaSelected
        model.caracteristica = this.objectSecound
        model.tipo_actividad_id = this.params.actividad
        console.log('caracteristica', model.caracteristica)
        console.log('objectSecound', this.objectSecound)
      }

      // console.log(model)
      if (this.UrlexecuteMain) this.POSTExecuteService({ url: this.UrlexecuteMain, data: model })
      else this.POSTExecuteService({ url: this.params.url, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object', 'get_options', 'get_objectFamily', 'get_model'])
  },
  watch: {
    get_object (val) {
      this.HIDDE_LOADING_MAIN(false)
      if (val.message) {
        this.$swal({ type: 'error', icon: 'error', title: 'Error!', text: val.message })
        return
      }
      this.$swal({ type: 'success', icon: 'success', title: 'Exitoso!', text: this.params.message })
      if (this.params.returnObject) {
        this.SEND_DATA_VIEW({ name: this.get_dialogMain.type, model: val })
        this.cancel()
        return
      } else if (this.get_dialogMain.body && this.get_dialogMain.body.content === 'form-data') {
        this.cancel()
        return
      }
      this.SET_DATA_OBJECT(val)
      this.cancel()
    },
    get_objectFamily (val) {
      this.formSecound = val.fields
      this.showFormSecound = true
      if (!this.params.updated) this.objectSecound = {}
    },
    get_options (val) {
      if (this.params.showActividad) {
        this.formMain = val
        this.showFormMain = true
      } else if (this.params.showFamilia) {
        this.formMain = val
        if (this.params.process === 6) {
          this.formMain.status_finish.formulario.fields.map(fiel => {
            if (fiel.hidden) fiel.hidden = false
          })
        }
      } else {
        const form = JSON.parse(JSON.stringify(val))
        if (this.params.setfilter) {
          form.status_finish.formulario.fields.map(field => {
            if (field.nameid === 'bajas') {
              field.data = this.params.filter
            }
            if (field.nameid === 'transferencias') {
              field.data = this.params.filter
            }
          })
        }
        this.formMain = form
      }
      this.showFormMain = true
    },
    get_model (val) {
      this.HIDDE_LOADING_MAIN(false)
      if (val.message) {
        this.$swal({ type: 'error', icon: 'error', title: 'Error !', text: val.message })
        return
      }
      this.$swal({ type: 'success', icon: 'success', title: 'Exitoso!', text: this.params.message, timer: 1500 })
      if (this.params.returnObject) {
        this.SEND_DATA_VIEW({ name: this.get_dialogMain.type, model: val })
        this.cancel()
        return
      } else if (this.get_dialogMain.body && this.get_dialogMain.body.content === 'form-data') {
        this.cancel()
        return
      }
      this.SET_DATA_OBJECT(val)
      this.cancel()
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS_MODEL()
  }
}
</script>

<style></style>
